import { i18n } from '../../../config/i18n'

const meanChart = {
    chart: {
        type: "bar",
    },

    plotOptions: {
        bar: {
            columnWidth: "85%",
        },
    },

    title: {
        text: i18n.global.t("media"),
        align: "center",
        margin: 10,
        offsetX: 0,
        offsetY: 0,
        floating: false,
        style: {
            fontSize: "14px",
            fontWeight: "bold",
            fontFamily: undefined,
            color: "#263238",
        },
    },

    dataLabels: {
        enabled: true,
        formatter: function (num, { seriesIndex, dataPointIndex, w }) {
            if (w.config.series[0].data.length > 1) {
                return ''
            }
            if (!isNaN(parseFloat(num))) {
                var numParsed = parseFloat(num);
                if (numParsed >= 1000000 || numParsed <= -1000000)
                    return numParsed.toExponential(3);
                if (
                    (numParsed > 0 && numParsed < 1) ||
                    (numParsed < 0 && numParsed > -1)
                ) {
                    numParsed = numParsed.toFixed(4);
                } else {
                    numParsed = numParsed.toFixed(2);
                }
                numParsed = numParsed.replace(".", ",").split(",");
                let v1 = numParsed[0];
                let v2 = numParsed[1];
                v1 = v1.split("").reverse();
                let i = 0;
                var stop = 0;
                if (v1.length / 3 >= 1 && v1.length % 3 != 0) {
                    i = 1;
                    stop = Math.trunc(v1.length / 3);
                }
                if (v1.length / 3 >= 1 && v1.length % 3 == 0) {
                    i = 1;
                    stop = Math.trunc(v1.length / 3) - 1;
                }
                var pos = 3;
                if (i >= 1) {
                    for (i; i <= stop; i++) {
                        v1.splice(pos, 0, ".");
                        pos = pos + 4;
                    }
                }
                numParsed = v1.reverse().join("") + "," + v2;
                if (numParsed.includes("-.")) {
                    numParsed = numParsed.replace("-.", "-");
                }
                return numParsed;
            }
            return;
        },
        style: {
            fontSize: "8px",
        },
    },

    xaxis: {
        categories: [],
        labels: {
            style: {
                fontSize: "12px",
            },
        },
    },

    yaxis: {
        labels: {
            formatter: function (num, opts) {
                if (!isNaN(parseFloat(num))) {
                    var numParsed = parseFloat(num);
                    if (numParsed >= 1000000 || numParsed <= -1000000)
                        return numParsed.toExponential(3);
                    if (
                        (numParsed > 0 && numParsed < 1) ||
                        (numParsed < 0 && numParsed > -1)
                    ) {
                        numParsed = numParsed.toFixed(4);
                    } else {
                        numParsed = numParsed.toFixed(2);
                    }
                    numParsed = numParsed.replace(".", ",").split(",");
                    let v1 = numParsed[0];
                    let v2 = numParsed[1];
                    v1 = v1.split("").reverse();
                    let i = 0;
                    var stop = 0;
                    if (v1.length / 3 >= 1 && v1.length % 3 != 0) {
                        i = 1;
                        stop = Math.trunc(v1.length / 3);
                    }
                    if (v1.length / 3 >= 1 && v1.length % 3 == 0) {
                        i = 1;
                        stop = Math.trunc(v1.length / 3) - 1;
                    }
                    var pos = 3;
                    if (i >= 1) {
                        for (i; i <= stop; i++) {
                            v1.splice(pos, 0, ".");
                            pos = pos + 4;
                        }
                    }
                    if (parseFloat(numParsed) >= 1000 || parseFloat(numParsed) <= -1000) {
                        numParsed = v1.reverse().join("")
                    }
                    else {
                        numParsed = v1.reverse().join("") + "," + v2;
                    }
                    if (numParsed.includes("-.")) {
                        numParsed = numParsed.replace("-.", "-");
                    }
                    return numParsed;
                }
                return;
            },
            style: {
                fontSize: "11px",
            },
        },
    },

    tooltip: {
        enabled: true,
        y: {
            show: true,
            formatter: function (num, { seriesIndex, dataPointIndex, w }) {
                if (!isNaN(parseFloat(num))) {
                    var numParsed = parseFloat(num);
                    if (numParsed >= 1000000 || numParsed <= -1000000)
                        return numParsed.toExponential(3);
                    if (
                        (numParsed > 0 && numParsed < 1) ||
                        (numParsed < 0 && numParsed > -1)
                    ) {
                        numParsed = numParsed.toFixed(4);
                    } else {
                        numParsed = numParsed.toFixed(3);
                    }
                    numParsed = numParsed.replace(".", ",").split(",");
                    let v1 = numParsed[0];
                    let v2 = numParsed[1];
                    v1 = v1.split("").reverse();
                    let i = 0;
                    var stop = 0;
                    if (v1.length / 3 >= 1 && v1.length % 3 != 0) {
                        i = 1;
                        stop = Math.trunc(v1.length / 3);
                    }
                    if (v1.length / 3 >= 1 && v1.length % 3 == 0) {
                        i = 1;
                        stop = Math.trunc(v1.length / 3) - 1;
                    }
                    var pos = 3;
                    if (i >= 1) {
                        for (i; i <= stop; i++) {
                            v1.splice(pos, 0, ".");
                            pos = pos + 4;
                        }
                    }
                    numParsed = v1.reverse().join("") + "," + v2;
                    if (numParsed.includes("-.")) {
                        numParsed = numParsed.replace("-.", "-");
                    }
                    return numParsed;
                }
                return;
            },
        },

        fixed: {
            enabled: true,
            position: 'topRight',
            offsetX: 0,
            offsetY: 0,
        }
    },

    colors: ["#660000", "#004c26"],
    series: [],
};

const ppkChart = {
    chart: {
        type: "bar"
    },
    title: {
        text: i18n.global.t('ppk'),
        align: "center",
        margin: 10,
        offsetX: 0,
        offsetY: 0,
        floating: false,
        style: {
            fontSize: "14px",
            fontWeight: "bold",
            fontFamily: undefined,
            color: "#263238",
        },
    },

    dataLabels: {
        enabled: true,
        formatter: function (num, { seriesIndex, dataPointIndex, w }) {
            if (w.config.series[0].data.length > 1) {
                return ''
            }
            if (!isNaN(parseFloat(num))) {
                var numParsed = parseFloat(num);
                if (
                    (numParsed > 0 && numParsed < 1) ||
                    (numParsed < 0 && numParsed > -1)
                ) {
                    numParsed = numParsed.toFixed(4);
                } else {
                    numParsed = numParsed.toFixed(3);
                }
                numParsed = numParsed.replace(".", ",").split(",");
                let v1 = numParsed[0];
                let v2 = numParsed[1];
                v1 = v1.split("").reverse();
                let i = 0;
                var stop = 0;
                if (v1.length / 3 >= 1 && v1.length % 3 != 0) {
                    i = 1;
                    stop = Math.trunc(v1.length / 3);
                }
                if (v1.length / 3 >= 1 && v1.length % 3 == 0) {
                    i = 1;
                    stop = Math.trunc(v1.length / 3) - 1;
                }
                var pos = 3;
                if (i >= 1) {
                    for (i; i <= stop; i++) {
                        v1.splice(pos, 0, ".");
                        pos = pos + 4;
                    }
                }
                numParsed = v1.reverse().join("") + "," + v2;
                if (numParsed.includes("-.")) {
                    numParsed = numParsed.replace("-.", "-");
                }
                return numParsed;
            }
            return;
        },
        style: {
            fontSize: "8px",
        },
    },

    xaxis: {
        labels: {
            style: {
                fontSize: "11px",
            },
        },
    },

    yaxis: {
        labels: {
            formatter: function (num, opts) {
                if (!isNaN(parseFloat(num))) {
                    var numParsed = parseFloat(num);
                    if (
                        (numParsed > 0 && numParsed < 1) ||
                        (numParsed < 0 && numParsed > -1)
                    ) {
                        numParsed = numParsed.toFixed(4);
                    } else {
                        numParsed = numParsed.toFixed(3);
                    }
                    numParsed = numParsed.replace(".", ",").split(",");
                    let v1 = numParsed[0];
                    let v2 = numParsed[1];
                    v1 = v1.split("").reverse();
                    let i = 0;
                    var stop = 0;
                    if (v1.length / 3 >= 1 && v1.length % 3 != 0) {
                        i = 1;
                        stop = Math.trunc(v1.length / 3);
                    }
                    if (v1.length / 3 >= 1 && v1.length % 3 == 0) {
                        i = 1;
                        stop = Math.trunc(v1.length / 3) - 1;
                    }
                    var pos = 3;
                    if (i >= 1) {
                        for (i; i <= stop; i++) {
                            v1.splice(pos, 0, ".");
                            pos = pos + 4;
                        }
                    }
                    numParsed = v1.reverse().join("") + "," + v2;
                    if (numParsed.includes("-.")) {
                        numParsed = numParsed.replace("-.", "-");
                    }
                    return numParsed;
                }
                return;
            },
        },
        noData: {
            text: i18n.global.t("sem-dados"),
            align: "center",
            verticalAlign: "middle",
            offsetX: 0,
            offsetY: 0,
            style: {
                color: undefined,
                fontSize: "11px",
                fontFamily: undefined,
            },
        },
    },
    colors: ["#660000"],
    series: [],
};

const reabilityChart = {
    chart: {
        type: "bar",
    },
    title: {
        text: i18n.global.t("aderencia-0"),
        align: "center",
        margin: 10,
        offsetX: 0,
        offsetY: 0,
        floating: false,
        style: {
            fontSize: "14px",
            fontWeight: "bold",
            fontFamily: undefined,
            color: "#263238",
        },
    },
    dataLabels: {
        enabled: true,
        // eslint-disable-next-line no-unused-vars
        formatter: function (num, { seriesIndex, dataPointIndex, w }) {
            if (w.config.series[0].data.length > 1) {
                return ''
            }
            return (num * 100).toFixed(2) + "%";
        },
        style: {
            fontSize: "8px",
        },
    },
    xaxis: {
        labels: {
            style: {
                fontSize: "11px",
            },
        },
    },
    yaxis: {
        min: 0,
        max: 1,
        labels: {
            // eslint-disable-next-line no-unused-vars
            formatter: function (num, opts) {
                return (num * 100).toFixed(2) + "%";
            },
        },
    },
    colors: ["#660000"],
    series: [],
};

const trendChart = {
    series: [],
    chart: {
        id: "area-datetime",
        defaultLocale: "pt-BR",
        locales: [
            {
                name: "pt-BR",
                options: {
                    months: [
                        i18n.global.t("janeiro"),
                        i18n.global.t("fevereiro"),
                        i18n.global.t("marco"),
                        i18n.global.t("abril"),
                        i18n.global.t("maio"),
                        i18n.global.t("junho"),
                        i18n.global.t("julho"),
                        i18n.global.t("agosto"),
                        i18n.global.t("setembro"),
                        i18n.global.t("outubro"),
                        i18n.global.t("novembro"),
                        i18n.global.t("dezembro"),
                    ],
                    shortMonths: [
                        i18n.global.t("jan"),
                        i18n.global.t("fev"),
                        i18n.global.t("mar"),
                        i18n.global.t("abr"),
                        i18n.global.t("mai"),
                        i18n.global.t("jun"),
                        i18n.global.t("jul"),
                        i18n.global.t("ago"),
                        i18n.global.t("set"),
                        i18n.global.t("out"),
                        i18n.global.t("nov"),
                        i18n.global.t("dez"),
                    ],
                    days: [
                        i18n.global.t("domingo"),
                        i18n.global.t("segunda"),
                        i18n.global.t("terca"),
                        i18n.global.t("quarta"),
                        i18n.global.t("quinta"),
                        i18n.global.t("sexta"),
                        i18n.global.t("sabado"),
                    ],
                    shortDays: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
                    toolbar: {
                        exportToSVG: "Download SVG",
                        exportToPNG: "Download PNG",
                        exportToCSV: "Download CSV",
                        menu: i18n.global.t("menu"),
                        selection: i18n.global.t("selecionar"),
                        selectionZoom: i18n.global.t("zoom-de-selecao"),
                        zoomIn: i18n.global.t("aumentar-zoom"),
                        zoomOut: i18n.global.t("diminuir-zoom"),
                        pan: i18n.global.t("panoramica"),
                        reset: i18n.global.t("restaurar-zoom"),
                    },
                },
            },
        ],
        type: "line",
        stacked: false,
        zoom: {
            autoScaleYaxis: true,
        },
    },

    colors: ["#660000", "#004c26", "#ff9a2e", "#800080"],

    yaxis: {
        labels: {
            // eslint-disable-next-line no-unused-vars
            formatter: function (num, opts) {
                if (!isNaN(parseFloat(num))) {
                    var numParsed = parseFloat(num);
                    if (
                        (numParsed > 0 && numParsed < 1) ||
                        (numParsed < 0 && numParsed > -1)
                    ) {
                        numParsed = numParsed.toFixed(4);
                    } else {
                        numParsed = numParsed.toFixed(3);
                    }

                    numParsed = numParsed.replace(".", ",").split(",");

                    let v1 = numParsed[0];
                    let v2 = numParsed[1];
                    v1 = v1.split("").reverse();
                    let i = 0;
                    var stop = 0;

                    if (v1.length / 3 >= 1 && v1.length % 3 != 0) {
                        i = 1;
                        stop = Math.trunc(v1.length / 3);
                    }

                    if (v1.length / 3 >= 1 && v1.length % 3 == 0) {
                        i = 1;
                        stop = Math.trunc(v1.length / 3) - 1;
                    }

                    var pos = 3;

                    if (i >= 1) {
                        for (i; i <= stop; i++) {
                            v1.splice(pos, 0, ".");
                            pos = pos + 4;
                        }
                    }

                    numParsed = v1.reverse().join("") + "," + v2;

                    if (numParsed.includes("-.")) {
                        numParsed = numParsed.replace("-.", "-");
                    }
                    return numParsed;
                }
                return null;
            },

            showForNullSeries: false,
            seriesName: i18n.global.t("valor"),
            tickAmount: 6,

            min: function (min) {
                return min;
            },
            max: function (max) {
                return max;
            },
            forceNiceScale: true,
            decimalsInFloat: 3,
        },
        annotations: {
            yaxis: [],
            xaxis: [],
        },

        noData: {
            text: i18n.global.t("sem-dados"),
            align: "center",
            verticalAlign: "middle",
            offsetX: 0,
            offsetY: 0,
            style: {
                color: undefined,
                fontSize: "14px",
                fontFamily: undefined,
            },
        },
        dataLabels: {
            enabled: true,
        },
    },

    markers: {
        size: 0,
        showNullDataPoints: true,
        hover: {
            sizeOffset: 4,
        },
        style: "hollow",
    },

    stroke: {
        width: [2, 2, 2, 2],
        dashArray: [0, 0, 0, 0],
    },

    xaxis: {
        type: "datetime",
        min: '',
        max: '',
        tickAmount: 6,
        tooltip: {
            enabled: false,
        },
        labels: {
            datetimeUTC: false,
        }
    },

    legend: {
        show: true,
        showForNullSeries: false,
    },

    tooltip: {
        enabled: true,
        shared: true,
        x: {
            show: false,
        },
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            let label = w.config.series[seriesIndex].name;
            let labelColor = w.config.colors[seriesIndex];
            let numParsed = w.config.series[seriesIndex].data[dataPointIndex].z;
            let datePoint = new Date(
                w.config.series[seriesIndex].data[dataPointIndex].x
            );
            datePoint = datePoint.toLocaleString("pt-BR");
            if (!isNaN(parseFloat(numParsed))) {
                numParsed = parseFloat(numParsed);
                if (
                    (numParsed > 0 && numParsed < 1) ||
                    (numParsed < 0 && numParsed > -1)
                ) {
                    numParsed = numParsed.toFixed(4);
                } else {
                    numParsed = numParsed.toFixed(3);
                }
                numParsed = numParsed.replace(".", ",").split(",");
                let v1 = numParsed[0];
                let v2 = numParsed[1];
                v1 = v1.split("").reverse();
                let i = 0;
                var stop = 0;
                if (v1.length / 3 >= 1 && v1.length % 3 != 0) {
                    i = 1;
                    stop = Math.trunc(v1.length / 3);
                }
                if (v1.length / 3 >= 1 && v1.length % 3 == 0) {
                    i = 1;
                    stop = Math.trunc(v1.length / 3) - 1;
                }
                var pos = 3;
                if (i >= 1) {
                    for (i; i <= stop; i++) {
                        v1.splice(pos, 0, ".");
                        pos = pos + 4;
                    }
                }
                numParsed = v1.reverse().join("") + "," + v2;
                if (numParsed.includes("-.")) {
                    numParsed = numParsed.replace("-.", "-");
                }
            }
            else {
                numParsed = "Sem dados..."
            }

            return (
                '<div class="arrow_box" style="padding: 10px;">' +
                '<div class="date-box"><b>' +
                datePoint +
                "</b></div>" +
                '<div class="label-box"><span style="margin-right: 5px;color:' +
                labelColor +
                ';">&#11044</span><span>' +
                label +
                ": " +
                numParsed +
                "</span></div>" +
                "</div>"
            );
        },
    },
};

export { meanChart, ppkChart, reabilityChart, trendChart };